import React, {FC} from "react";
import {Switch, Tooltip} from "antd";
import i18n from "../../../../services/i18n";

/** Filter „Mahnung fällig“ in Offene Zahlungen (#1517), Aufbau wie ShowDeletedToggle */
const DunningDueToggle: FC<{value: boolean; onChange: (value: boolean) => void}> = ({value, onChange}) => (
    <Tooltip title={i18n.containers.invoice.BookingDunnings.list.filterHint()} placement="top">
        <span style={{display: "inline-flex", alignItems: "center", gap: 6, padding: "0 8px", cursor: "pointer", userSelect: "none"}} onClick={() => onChange(!value)} data-testid="DunningDueToggle">
            <span style={{fontSize: 13, color: "rgba(0,0,0,0.65)"}}>{i18n.containers.invoice.BookingDunnings.list.filter()}</span>
            <Switch size="small" checked={value} onChange={onChange} onClick={(_checked, e) => e.stopPropagation()} />
        </span>
    </Tooltip>
);

export default DunningDueToggle;
